<h1 mat-dialog-title [class.gewicht-dialog__title--mobile]="isMobileScreen">Gewichte vor HIT-Meldung erfassen</h1>

<div mat-dialog-content class="gewicht-dialog-content" [class.gewicht-dialog-content--mobile]="isMobileScreen">
    <p class="gewicht-dialog-subtitle" *ngIf="!isLoading && rows.length > 0">
        Wählen Sie, wie die Einstallgewichte für {{ rows.length }} Tiere gesetzt werden sollen.
    </p>
    <p *ngIf="isLoading"><strong>Lade Tiere...</strong></p>

    <div *ngIf="!isLoading && rows.length === 0" class="empty-state">
        Keine zu meldenden Tiere gefunden.
    </div>

    <!-- Desktop -->
    <mat-tab-group
        *ngIf="!isMobileScreen && !isLoading && rows.length > 0"
        [selectedIndex]="activeTabIndex"
        (selectedIndexChange)="onTabIndexChanged($event)"
        dynamicHeight
    >
        <mat-tab label="Gesamtgewicht">
            <div class="tab-panel tab-panel--split">
                <mat-form-field appearance="outline" class="wide-field">
                    <mat-label>Gesamtgewicht (kg)</mat-label>
                    <input matInput type="number" min="0.1" step="0.1" [(ngModel)]="totalGewicht" (ngModelChange)="onTotalGewichtChanged()" />
                </mat-form-field>

                <div class="info-card" *ngIf="rows.length > 0">
                    <div class="info-card__row">
                        <span class="info-card__label">Tiere (ohne Gewicht)</span>
                        <strong>{{ editableRowCount }}</strong>
                    </div>
                    <div class="info-card__row">
                        <span class="info-card__label">Gewicht je Tier</span>
                        <strong>{{ calculatedWeightFromTotal | number: '1.1-1' : 'de' }} kg</strong>
                    </div>
                </div>
            </div>
        </mat-tab>

        <mat-tab label="Einzeltiergewicht">
            <div class="tab-panel tab-panel--split">
                <mat-form-field appearance="outline" class="wide-field">
                    <mat-label>Gewicht je Tier (kg)</mat-label>
                    <input
                        matInput
                        type="number"
                        min="0.1"
                        step="0.1"
                        [(ngModel)]="gleichesGewicht"
                        (ngModelChange)="onGleichesGewichtChanged()"
                    />
                </mat-form-field>

                <div class="info-card">
                    <div class="info-card__row">
                        <span class="info-card__label">Gesamt</span>
                        <strong>{{ ((gleichesGewicht || 0) * editableRowCount) | number: '1.1-1' : 'de' }} kg</strong>
                    </div>
                    <div class="info-card__row">
                        <span class="info-card__label">Tiere (ohne Gewicht)</span>
                        <strong>{{ editableRowCount }}</strong>
                    </div>
                </div>
            </div>
        </mat-tab>

        <mat-tab label="Einzeltier">
            <div class="rows-wrap" [class.rows-wrap--scrollable]="rows.length > 4">
                <div *ngFor="let row of rows; let i = index" class="gewicht-row">
                    <div class="tier-label" [title]="row.tier.ohrmarke_notnull || ''">
                        <span class="index">{{ i + 1 }}.</span>
                        <kiene-ohrmarke class="tier-label__ohrmarke-full" [ohrmarke]="row.tier.ohrmarke_notnull"></kiene-ohrmarke>
                    </div>
                    <mat-form-field appearance="outline" class="gewicht-field">
                        <mat-label>Gewicht (kg)</mat-label>
                        <input matInput type="number" min="0.1" step="0.1" [(ngModel)]="row.gewicht" (ngModelChange)="onRowGewichtChanged()" />
                    </mat-form-field>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>

    <!-- Mobile -->
    <div *ngIf="isMobileScreen && !isLoading && rows.length > 0" class="gewicht-dialog-mobile">
        <div class="gewicht-dialog-mobile__tabs" role="tablist" aria-label="Gewichtserfassung">
            <button
                type="button"
                mat-icon-button
                class="gewicht-dialog-mobile__tab-nav"
                aria-label="Vorheriger Modus"
                [disabled]="activeTabIndex === 0"
                (click)="previousTab()"
            >
                <mat-icon>chevron_left</mat-icon>
            </button>
            <span class="gewicht-dialog-mobile__tab-label" role="tab" aria-selected="true" [@mobileTabLabel]="activeTabIndex">{{
                activeTabLabel
            }}</span>
            <button
                type="button"
                mat-icon-button
                class="gewicht-dialog-mobile__tab-nav"
                aria-label="Nächster Modus"
                [disabled]="activeTabIndex >= tabLabels.length - 1"
                (click)="nextTab()"
            >
                <mat-icon>chevron_right</mat-icon>
            </button>
        </div>

        <div class="gewicht-dialog-mobile__panel-host" [@mobileTabSlide]="activeTabIndex">
        <div *ngIf="activeTabIndex === 0" class="gewicht-dialog-mobile__panel">
            <input
                class="gewicht-dialog-mobile__input"
                type="number"
                inputmode="decimal"
                min="0.1"
                step="0.1"
                placeholder="Gesamtgewicht (kg)"
                [(ngModel)]="totalGewicht"
                (ngModelChange)="onTotalGewichtChanged()"
            />
            <div class="gewicht-dialog-mobile__summary">
                <div class="gewicht-dialog-mobile__summary-row">
                    <span class="gewicht-dialog-mobile__summary-label">Tiere (ohne Gewicht)</span>
                    <strong class="gewicht-dialog-mobile__summary-value">{{ editableRowCount }}</strong>
                </div>
                <div class="gewicht-dialog-mobile__summary-row">
                    <span class="gewicht-dialog-mobile__summary-label">Gewicht je Tier</span>
                    <strong class="gewicht-dialog-mobile__summary-value"
                        >{{ calculatedWeightFromTotal | number: '1.1-1' : 'de' }} kg</strong
                    >
                </div>
            </div>
        </div>

        <div *ngIf="activeTabIndex === 1" class="gewicht-dialog-mobile__panel">
            <input
                class="gewicht-dialog-mobile__input"
                type="number"
                inputmode="decimal"
                min="0.1"
                step="0.1"
                placeholder="Gewicht je Tier (kg)"
                [(ngModel)]="gleichesGewicht"
                (ngModelChange)="onGleichesGewichtChanged()"
            />
            <div class="gewicht-dialog-mobile__summary">
                <div class="gewicht-dialog-mobile__summary-row">
                    <span class="gewicht-dialog-mobile__summary-label">Gesamt</span>
                    <strong class="gewicht-dialog-mobile__summary-value"
                        >{{ ((gleichesGewicht || 0) * editableRowCount) | number: '1.1-1' : 'de' }} kg</strong
                    >
                </div>
                <div class="gewicht-dialog-mobile__summary-row">
                    <span class="gewicht-dialog-mobile__summary-label">Tiere (ohne Gewicht)</span>
                    <strong class="gewicht-dialog-mobile__summary-value">{{ editableRowCount }}</strong>
                </div>
            </div>
        </div>

        <div *ngIf="activeTabIndex === 2" class="gewicht-dialog-mobile__panel gewicht-dialog-mobile__panel--einzeltier">
            <div class="rows-wrap rows-wrap--mobile" [class.rows-wrap--scrollable]="rows.length > 4">
                <div *ngFor="let row of rows; let i = index" class="gewicht-row gewicht-row--mobile">
                    <div class="tier-label" [title]="row.tier.ohrmarke_notnull || ''">
                        <span class="index">{{ i + 1 }}.</span>
                        <span class="tier-label__ohrmarke10">{{ getOhrmarke10(row.tier.ohrmarke_notnull) }}</span>
                    </div>
                    <input
                        class="gewicht-dialog-mobile__input gewicht-dialog-mobile__input--row"
                        type="number"
                        inputmode="decimal"
                        min="0.1"
                        step="0.1"
                        placeholder="Gewicht (kg)"
                        [(ngModel)]="row.gewicht"
                        (ngModelChange)="onRowGewichtChanged()"
                    />
                </div>
            </div>
        </div>
        </div>
    </div>
</div>

<div mat-dialog-actions class="gewicht-dialog-actions" [class.gewicht-dialog-actions--mobile]="isMobileScreen">
    <button
        mat-button
        class="gewicht-dialog-actions__cancel"
        (click)="close()"
        [disabled]="isSaving"
    >
        Abbrechen
    </button>
    <button
        mat-flat-button
        color="accent"
        class="gewicht-dialog-actions__save"
        (click)="save()"
        [disabled]="isLoading || isSaving"
    >
        {{ isSaving ? 'Speichern...' : 'Übernehmen' }}
    </button>
</div>
